import {Card} from "../../../../models/loyalty-card.model";

export enum CustomerCardSearchModelFilterTypes {
  None = 0,
  LoyaltyChannel = 1
}

export class CustomerCardSearchModelFilter {
  type: CustomerCardSearchModelFilterTypes = CustomerCardSearchModelFilterTypes.None;
  filterCard: Card = null;

}




// WEBPACK FOOTER //
// ./src/app/views/customerDB/widget/customer-card-search/customer-card-search.model.ts